import React, { ReactNode, FunctionComponent } from 'react';
import Hint, { HintColor, HintAlign } from 'components/hint/hint';

type PageFooterProps = {
    links?: ReactNode;
    socialLinks?: ReactNode;
    hint?: ReactNode;
    copyright?: ReactNode;
};

const PageFooter: FunctionComponent<PageFooterProps> = (props) => {
    const { links, socialLinks, hint, copyright } = props;

    return (
        <footer className="page-footer">
            {hint ? (
                <div className="page-footer__hint">
                    <Hint color={HintColor.GRAY_DARK} align={HintAlign.CENTER}>
                        {hint}
                    </Hint>
                </div>
            ) : null}
            {socialLinks ? <div className="page-footer__social-links">{socialLinks}</div> : null}
            {links ? <div className="page-footer__links">{links}</div> : null}
            {copyright ? <div className="page-footer__copyright">{copyright}</div> : null}
        </footer>
    );
};

export default PageFooter;
